module.exports = __webpack_public_path__ + "static/media/upload.bb9e6750.svg";